import React, { FC } from 'react';
import EnvironmentStore from 'lib/stores/environmentStore';

interface GenerateButtonProps {
  generate: () => void
}

const GenerateButton: FC<GenerateButtonProps> = ({ generate }) => {
  const { generate_buttons = 'false' } = EnvironmentStore.useState(state => state);

  if (generate_buttons === 'false') return <></>;

  return (
    <button type="button" className="btn btn-primary mt-3" onClick={generate}>Generate</button>
  );
};

export default GenerateButton;
